const routers = [
    {
      // 打印入库票据
      path: '/outstorenote/list',
      name: 'outstorenote',
      component: () => import('@/views/modules/outstore/outstorenote/List.vue')
    },
    {
      // 入库扫码记录
      path: '/scaninrecord/list',
      name: 'scaninrecord',
      component: () => import('@/views/modules/outstore/scaninrecord/List.vue')
    },
    {
      // 出库扫码记录
      path: '/scanoutrecord/list',
      name: 'scanoutrecord',
      component: () => import('@/views/modules/outstore/scanoutrecord/List.vue')
    },
    {
      // 每日汇总
      path: '/dailySummary/list',
      name: 'dailySummary',
      component: () => import('@/views/modules/outstore/dailySummary/List.vue')
    },
    {
      // 汇总
      path: '/allSummary/list',
      name: 'allSummary',
      component: () => import('@/views/modules/outstore/allSummary/List.vue')
    }
  ]
  export default routers
  